module.exports = __webpack_public_path__ + "static/media/winedata.03d7d984.csv";